import get from 'lodash.get';
import { RESET_STATE } from 'services/auth/constants';
import {
    FERTILIZER_EVENTS_LOAD_SUCCEEDED,
    FERTILIZER_EVENT_DELETE_SUCCEEDED,
    FERTILIZER_EVENT_SET,
    FERTILIZER_EVENTS_SET
} from './constants';
import { FertilizerEventActions, FertilizerEventsState } from './types';

const initialState: FertilizerEventsState = {};

export default function fertilizerEventsReducer(
    state: FertilizerEventsState = initialState,
    action: FertilizerEventActions
): FertilizerEventsState {
    switch (action.type) {
        case FERTILIZER_EVENT_SET:
        case FERTILIZER_EVENTS_SET:
            return {
                ...state,
                ...get(action, 'payload', {})
            };
        case FERTILIZER_EVENTS_LOAD_SUCCEEDED:
            return get(action, 'payload', {});
        case FERTILIZER_EVENT_DELETE_SUCCEEDED: {
            const uuids = action.payload;

            const copy = { ...state };

            uuids.map((uuid) => delete copy[uuid]);

            return copy;
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
